import { render, staticRenderFns } from "./WX.vue?vue&type=template&id=65786900&scoped=true&"
import script from "./WX.vue?vue&type=script&lang=js&"
export * from "./WX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65786900",
  null
  
)

export default component.exports